module.exports = __webpack_public_path__ + "img/dowload-file.119c329e.svg";